// OrientationLockHistoryBadge.tsx
import React from "react";
import { View, Text, ScrollView, Pressable } from "react-native";
import * as SO from "expo-screen-orientation";
import { useOrientationLockHistory } from "./useOrientationLockHistory";

export default function OrientationLockHistoryBadge({
  limit = 80,
}: {
  limit?: number;
}) {
  const { history, clear } = useOrientationLockHistory(limit);
  const rows = [...history].reverse();

  return (
    <View
      style={{
        padding: 10,
        borderRadius: 10,
        backgroundColor: "#eee",
        maxHeight: 240,
        width: "100%",
      }}
    >
      <View
        style={{
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 6,
        }}
      >
        <Text style={{ fontWeight: "600" }}>Orientation lock history</Text>
        <Pressable
          onPress={clear}
          style={{ paddingHorizontal: 8, paddingVertical: 4 }}
        >
          <Text style={{ textDecorationLine: "underline" }}>Clear</Text>
        </Pressable>
      </View>
      <ScrollView>
        {rows.length === 0 ? (
          <Text>— no entries yet —</Text>
        ) : (
          rows.map((e, i) => (
            <View key={e.ts + ":" + i} style={{ paddingVertical: 2 }}>
              <Text>
                {time(e.ts)} • {label(e.lock)} {e.note} {e.method}
              </Text>
            </View>
          ))
        )}
      </ScrollView>
    </View>
  );
}

function label(lock: SO.OrientationLock | null) {
  if (lock == null) return "Unknown";
  switch (lock) {
    case SO.OrientationLock.DEFAULT:
      return "Default (system)";
    case SO.OrientationLock.ALL:
      return "All";
    case SO.OrientationLock.PORTRAIT:
      return "Portrait";
    case SO.OrientationLock.PORTRAIT_UP:
      return "Portrait up";
    case SO.OrientationLock.PORTRAIT_DOWN:
      return "Portrait down";
    case SO.OrientationLock.LANDSCAPE:
      return "Landscape";
    case SO.OrientationLock.LANDSCAPE_LEFT:
      return "Landscape left";
    case SO.OrientationLock.LANDSCAPE_RIGHT:
      return "Landscape right";
    default:
      return String(lock);
  }
}

function time(ts: number) {
  const d = new Date(ts);
  return (
    d.toLocaleTimeString?.() ??
    `${d.getHours()}:${String(d.getMinutes()).padStart(2, "0")}:${String(
      d.getSeconds()
    ).padStart(2, "0")}`
  );
}
